<template>
  <el-radio-button v-bind="$attrs"> <slot /> </el-radio-button>
</template>

<script>
export default {
  name: 'RtRadioButton'
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtRadioButton.vue?5583a29d